module.exports = __webpack_public_path__ + "static/media/18ECA24.fb6ae8a8.jpg";